import { render, staticRenderFns } from "./InformePreliminar.vue?vue&type=template&id=6de4827a&"
import script from "./InformePreliminar.vue?vue&type=script&lang=js&"
export * from "./InformePreliminar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports